import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

interface DaySelectorProps {
  days: (number | string)[];
  selectedDay: string | null;
  segmentsByDay: Record<string | number, any[]>;
  onDaySelect: (day: string) => void;
}

function DaySelector({ days, selectedDay, segmentsByDay, onDaySelect }: DaySelectorProps) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {days.map(day => {
        const daySegments = segmentsByDay[day] || [];
        const hasTravelSegment = daySegments.some(
          (seg: any) => seg.isCityTravel || seg.segment_type === 'city_travel'
        );
        const isSelected = selectedDay === String(day);

        return (
          <Chip
            key={day}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <span>Day {day}</span>
                {hasTravelSegment && (
                  <DirectionsCarIcon sx={{ fontSize: 16 }} />
                )}
              </Box>
            }
            onClick={() => onDaySelect(String(day))}
            color={isSelected ? 'primary' : 'default'}
            variant={isSelected ? 'filled' : 'outlined'}
            sx={{
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
              transform: isSelected ? 'scale(1.05)' : 'scale(1)',
              '&:hover': {
                backgroundColor: isSelected ? 'primary.main' : 'action.hover',
                transform: 'scale(1.05)'
              }
            }}
          />
        );
      })}
    </Box>
  );
}

export default DaySelector;
